export function voiceCallDate(value: string | number | null | undefined, language: string): string {
  const timestamp = typeof value === 'number' ? (value > 1e11 ? value : NaN) : value ? Date.parse(value) : NaN;
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return '—';
  return new Intl.DateTimeFormat(language === 'de' ? 'de-AT' : 'en-GB', {
    timeZone: 'Europe/Vienna', dateStyle: 'medium', timeStyle: 'medium',
  }).format(date);
}
export function voiceCallDuration(start?: string | null, end?: string | null): string {
  if (!start || !end) return '—';
  const seconds = Math.floor((Date.parse(end) - Date.parse(start)) / 1000);
  if (!Number.isFinite(seconds) || seconds < 0) return '—';
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
export function voiceCallJson(value: unknown): string {
  if (value == null) return '—';
  if (typeof value === 'string') {
    try { return JSON.stringify(JSON.parse(value), null, 2); } catch { return value; }
  }
  return JSON.stringify(value, null, 2);
}
